import { render, staticRenderFns } from "./RatingConfigList.vue?vue&type=template&id=bfe50f80&"
import script from "./RatingConfigList.vue?vue&type=script&lang=js&"
export * from "./RatingConfigList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports